///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Globals Module
//
///////////////////////////////////////////////////////////////////////////////////////////////////

import $ from 'jquery';
import moment from 'moment-timezone';

const globals = {
    deployment: '',

    // Move DOM-ready bindings here and call init()
    async register() {
        $(() => {
            // Initialize global UI helpers
            globals.init();

            // Hide the mobile navbar menu when a modal is shown
            $('div.modal')
                .off('show.bs.modal.globals')
                .on('show.bs.modal.globals', function() {
                    $('nav.navbar-portal .navbar-collapse.show').removeClass('show');
                });
        });
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    init: function() {
        // Global tool tips
        $('[data-toggle="tooltip"], a.tooltip-manual').tooltip();

        // Global popovers
        $('[data-toggle="popover"]').popover({
            trigger: 'focus',
            container: 'body',
            html: true
        });

        // Hide popovers when they're clicked on outside
        $('*').off('click.globals').on('click.globals', function (e) {
            if ($(e.target).data('toggle') == 'popover') {
                if (!$(e.target).attr('aria-describedby')) {
                    $('[data-toggle="popover"]').popover('hide');
                }

            } else if ($(e.target).parents('.popover.in').length === 0) {
                $('[data-toggle="popover"]').popover('hide');
            }
        });

        globals.deployment = $('#globals').find('#deployment').val();
    },

    /**
     * Block the UI, optionally show a progress wheel
     */
    blockUI: function(show = false) {
        $('#blocker').addClass('on');

        if (show) {
            $('#blocker').addClass('progress');
        }
    },


    /**
     * Unblock the UI
     */
    unblockUI: function() {
        $('#blocker').removeClass('on progress');
    },


    /**
     *
     * @param {*} elem
     */
    updateModalInput: function(elem) {
        // Trigger the event for vuejs
        var event; // The custom event that will be created

        if (document.createEvent) {
            event = document.createEvent("HTMLEvents");
            event.initEvent("input", true, true);
        } else {
            event = document.createEventObject();
            event.eventType = "input";
        }

        elem[0].dispatchEvent(event);
    },


    /**
     *
     */
    getTimeZone: function() {
        var tz = moment.tz(moment.tz.guess()).format('z'); // moment-timezone
        return tz;

        /*
        var tz = /\((.*)\)/.exec(new Date().toString())[1];

        if (tz) {
            tz = tz.match(/\b(\w)/g);
            tz = tz.join('');
        }

        return tz;
        */
    },


    /**
     *
     */
    uniqueID: function() {
        return '_' + Math.random().toString(36).substr(2, 9);
    }
};

export default globals;
